import { Component, Inject } from '@angular/core';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { NotifierInterface } from '../../../core/interfaces/notifier.interface';
import { AppMaterialModule } from '../../material/app-material.module';

@Component({
  selector: 'app-notifier',
  templateUrl: './notifier.component.html',
  styleUrls: ['./notifier.component.scss'],
  standalone: true,
  imports: [AppMaterialModule]
})
export class NotifierComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA)
    public data: Omit<NotifierInterface, 'messageType'>,
    public snackBarRef: MatSnackBarRef<NotifierComponent>
  ) {}
}
